var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markings-type-select-buttons"},_vm._l((_vm.units),function(unit){return _c('div',{key:unit.id,staticClass:"type-select-button",class:{
      selected: _vm.innerValue === unit.id,
    },on:{"click":function($event){_vm.innerValue = unit.id}}},[_vm._v(" "+_vm._s(unit.name.toUpperCase())+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }